<script>
    import Button from '@smui/button/styled';
    import Textfield from '@smui/textfield/styled';
    import { api_host, user_store, domain_code_store, avatar_store } from '../stores.js';
    import { doFetch } from '../utils/Fetching.svelte';
    // import { google_user } from '../utils/auth.js';
    import { toast_message } from '../utils/toast_message.js';
    import { onMount } from 'svelte';


    let domain_code = '';
    domain_code_store.subscribe(value => { domain_code = value; });

    // ?redirect=/job_review/123 returns there after login; only same-site paths are allowed
    const get_after_login_url = () => {
        const redirect = new URLSearchParams(window.location.search).get('redirect');
        if (!redirect) return '/jobs';
        try {
            const target = new URL(redirect, window.location.origin);
            if (target.origin === window.location.origin) return target.pathname + target.search + target.hash;
        } catch (e) {}
        return '/jobs';
    };
    const after_login_url = get_after_login_url();

    user_store.subscribe(value => {
        if (value['is_authenticated']) window.location.href = after_login_url;
    });

    let avatar = '';
    let email = "";
    let password = "";
    let checked = true;
    let resend_huid = null;
    let is_resend_btn = false;

    let is_button_disabled = false;
    let login_state = true;
    $: title = login_state ? "Login" : "Forgot / Reset password";
    $: action_link_title = login_state ? "Forgot / Reset password?" : "Login";
    $: button_title = login_state ? "Login" : "Send password reset email";

    let is_height_fit = true;
    onMount(() => {
        if (window.innerHeight < 580) {
            is_height_fit = false;
        }
    });

    avatar_store.subscribe(value => {
        avatar = value;
    });

    function doForgotPassword() {
        is_resend_btn = false;
        login_state = !login_state;
        password = "";
    }

    function doSignup() {
        is_resend_btn = false;
        window.location.href = '/register';
    }

    const login = async () => {
        is_resend_btn = false;
        const mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        if (!email.match(mailformat)) {
            toast_message(false, 'Invalid email address', 3000);
            return;
        }

        is_button_disabled = true;
        const res = await doFetch(api_host + '/auth/login', 'POST', {
            // username: `90fbfc42-99d4-11ec-987f-04d9f503b871.${email}`,
            username: `${domain_code}${email}`.toLowerCase(),
            password
        }, {'Content-Type': 'application/json', 'DomainCode': domain_code});
        is_button_disabled = false;
        const { token } = res;
        if (token) {
            const user_res = await doFetch(
                api_host + `/auth/user`,
                'GET',
                {},
                { Authorization: `${'Token'} ${token}`, 'Content-Type': 'application/json', 'DomainCode': domain_code }
            );
            // if (user_res.plan_type === 'prime' || user_res.role === 'admin' || user_res.role === 'manager') {
            toast_message(true, 'Successfully logged in', 2000);
            localStorage.setItem('HoyToKenTy', 'Token');
            localStorage.setItem('HoyToKenTo', token);
            localStorage.setItem('HoyDoMainCode', domain_code);
            window.location.href = after_login_url;
            // } else {
            //     toast_message(false, 'Login not available', 3000);
            //     return;
            // }
        } else {
            const admin_res = await doFetch(api_host + '/auth/login', 'POST', {
                username: `${email}`.toLowerCase(),
                password
            }, {'Content-Type': 'application/json', 'DomainCode': null});
            const { token } = admin_res;
            if (token) {
                toast_message(false, 'Please login at App.HouseofYards.com', 3000);
                return;
            }
            if (res.msg == 'Please activate your account first') {
                is_resend_btn = true;
                resend_huid = res.huid;
            }
            toast_message(false, res.non_field_errors || res.msg || 'Login failed', 3000);
        }
    }

    const resend_activation_email = async () => {
        is_resend_btn = false;
        is_button_disabled = true;
        const res = await doFetch(
            api_host + '/auth/resend/activation',
            'POST',
            { huid: resend_huid },
            { 'Content-Type': 'application/json', 'DomainCode': domain_code }
        );
        is_button_disabled = false;
        if (res.status) {
            toast_message(true, res.msg, 2000);
        } else {
            toast_message(false, res.msg || 'Resending Email failed', 3000);
        }
    }

    const forgot_password = async () => {
        is_button_disabled = true;
        const res = await doFetch(
            api_host + '/auth/forgot_password',
            'POST',
            { username: `${domain_code}${email}`.toLowerCase() },
            { 'Content-Type': 'application/json', 'DomainCode': domain_code }
        );
        is_button_disabled = false;
        console.log(res);
        if (res.status) {
            toast_message(true, res.msg, 2000);
        } else {
            if (!res.is_active) {
                toast_message(false, res.msg || 'Your account is inactive', 3000);
                return;
            }
            const admin_res = await doFetch(
                api_host + '/auth/forgot_password',
                'POST',
                { username: `${email}`.toLowerCase() },
                { 'Content-Type': 'application/json', 'DomainCode': null }
            );
            if (admin_res.status) {
                toast_message(false, 'Please try at HouseofYards.com', 3000);
                return;
            }
            toast_message(false, res.msg || 'Resending Email failed', 3000);
        }
    }
</script>

<div style={is_height_fit ? "height: 100%;" : "height: 100%;overflow-y: scroll"} id="form_container">
    <div class="formholder">
        <div class="companyimageholder">
            <a href="/">
                {#if avatar}
                    <img class="avatar" src="{avatar}" alt="d" />
                {/if}
            </a>
        </div>

        <div class="loginformholder">
            <div class="pagetitle logintitle">{title}</div>

            <div class="ff email">
                <Textfield 
                    required
                    type="email"
                    style="width: 100%;"
                    helperLine$style="width: 100%;" 
                    variant="outlined"
                    bind:value={email}
                    on:keypress={(e) => e.code == 'Enter' ? login() : ''}
                    label="Email Address"
                />
            </div>

            {#if login_state}
            <div class="ff password">
                <Textfield 
                    required
                    type="password"
                    style="width: 100%;"
                    helperLine$style="width: 100%;" 
                    variant="outlined" 
                    bind:value={password}
                    on:keypress={(e) => e.code == 'Enter' ? login() : ''}
                    label="Password"
                />
            </div>
            {/if}

            {#if is_resend_btn}
                <div style="text-align: right;">
                    <div class="ff signup" style="padding-top: 0px;">
                        <a on:click={resend_activation_email}>Didn't get activation Email? Resend</a>
                    </div>
                </div>
            {/if}

            <div class="ff buttonbar">
                <Button variant="raised" class="button-shaped-round" disabled={is_button_disabled} on:click={() => {
                    if (login_state) login();
                    else forgot_password();
                }}>{button_title}</Button>
            </div>
        
            <!-- {#if $google_user}
                <h1 style="display: none;">{$google_user.profile.name}</h1>
            {/if} -->
            
            <div class="exception">
                <div class="ff forgotpassword">
                    <a on:click={doForgotPassword}>{action_link_title}</a>
                </div>
        
                <div class="ff home_redirect">
                    <a href='/home'>Home</a>
                </div>
            </div> 
        </div>
    </div>
</div>

<style>

    /* globals */
    .ff {
        padding: 10px;
    }

    .formholder {
        width: 500px;
        margin-left: auto;
        margin-right: auto;
        margin-top: 50px;
    }

    .companyimageholder {
        width: 150px;
        margin-left: auto;
        margin-right: auto;
        margin-bottom: 25px;
    }
    .companyimageholder img {
        width: 100%;
    }

    .loginformholder {
        width: 100%;
        margin-left: auto;
        margin-right: auto;
        gap: 10px;
        grid-template-columns: repeat(2, 1fr);
        grid-template-areas: "pt pt"
                             "em em"
                             "pw pw"
                             "rm rm"
                             "bb bb"
                             "fp su";
    }

    .exception {
        display: flex;
        justify-content: space-between;
    }

    @media (max-device-width: 1024px), (max-width: 1023px) {
        .formholder {
            width: 90%;
            margin-left: auto;
            margin-right: auto;
            margin-top: 50px;
        }

        .loginformholder {
            width: 100%;
            margin-left: auto;
            margin-right: auto;
            display: grid;
            gap: 10px;
            grid-template-columns: repeat(1, 1fr);
            grid-template-areas: "pt"
                                "em"
                                "pw"
                                "rm"
                                "bb"
                                "fp"
                                "su";
            }

            .forgotpassword, .home_redirect {
                text-align: center;
            }
    }

    .pagetitle {
        grid-area: pt;
        padding-left: 10px;
    }

    .email {
        grid-area: em;
    }

    .password {
        grid-area: pw;
    }
    * :global(.mdc-button) {
        width: 100% !important;
        color: white !important;
    }

    .forgotpassword {
        grid-area: fp;
        font-size: 14px;
    }
    .home_redirect {
        grid-area: su;
        font-size: 14px;
    }
    * :global(a) {
        color: rgb(0, 179, 0) !important;
        cursor: pointer;
    }
    .signup {
        grid-area: su;
        font-size: 14px;
    }


</style>